import { monthLabel } from './period'

export function formatNumber(value) {
  return Number(value || 0).toLocaleString('da-DK', { maximumFractionDigits: 0 })
}

export function formatDateTime(value) {
  if (!value) return ''
  const raw = String(value).replace('T', ' ')
  const month = raw.substring(5, 7)
  const day = raw.substring(8, 10)
  const time = raw.substring(11, 16)
  return `${day}.${month} ${time}`
}

export function formatTime(value) {
  if (!value) return ''
  return String(value).replace('T', ' ').substring(11, 16)
}

export function formatPeriodStart(start) {
  return formatDateTime(start)
}

export function formatPeriodEnd(start, end) {
  if (!end) return ''
  if (!start) return formatDateTime(end)

  const startDate = String(start).replace('T', ' ').substring(0, 10)
  const endDate = String(end).replace('T', ' ').substring(0, 10)
  if (startDate === endDate) {
    return formatTime(end)
  }
  return formatDateTime(end)
}

export function formatCorrectionWhen(value) {
  if (!value) return ''
  const raw = String(value).replace('T', ' ')
  const day = raw.substring(8, 10)
  const month = raw.substring(5, 7)
  const time = raw.substring(11, 16)
  return `${day}.${month} kl. ${time}`
}

export function isAdminBooking(row) {
  return String(row && row.isAdminBooking) === '1'
}

export function formatKmCorrection(correction) {
  if (!correction) return ''
  const changes = []
  if (Number(correction.kmStandStartOld) !== Number(correction.kmStandStartNew)) {
    changes.push(
      `start ${formatNumber(correction.kmStandStartOld)}→${formatNumber(correction.kmStandStartNew)}`
    )
  }
  if (Number(correction.kmStandEndOld) !== Number(correction.kmStandEndNew)) {
    changes.push(
      `slut ${formatNumber(correction.kmStandEndOld)}→${formatNumber(correction.kmStandEndNew)}`
    )
  }
  if (!changes.length) return ''

  const when = formatCorrectionWhen(correction.created)
  const by = (correction.editedByName || '').trim()
  const byPart = by ? ` af ${by}` : ''
  return `Km rettet ${when}${byPart}: ${changes.join(', ')}. `
    + `Pris ${formatNumber(correction.totalPriceOld)}→${formatNumber(correction.totalPriceNew)} kr.`
}

export function formatNotesParts(row) {
  const parts = []
  if (isAdminBooking(row)) {
    parts.push('Administratorbooking')
  }
  const comment = ((row && row.comment) || '').trim()
  if (comment) {
    parts.push(comment)
  }
  const corrections = (row && row.kmCorrections) || []
  corrections.forEach((correction) => {
    const text = formatKmCorrection(correction)
    if (text) parts.push(text)
  })
  return parts
}

export function hasKmGap(usages, index, vehicleFilterActive) {
  if (!vehicleFilterActive || index === 0) return false
  const prev = usages[index - 1]
  const curr = usages[index]
  return Number(prev.kmStandEnd) !== Number(curr.kmStandStart)
}

export function buildPageTitle({ selectedYear, selectedMonth, subscription, isAdmin, accountName }) {
  const period = `${monthLabel(selectedMonth, { lowercase: true })} ${selectedYear}`
  let household = 'Alle'
  if (subscription && subscription.accountName) {
    household = subscription.accountName
  } else if (!isAdmin && accountName) {
    household = accountName
  }
  return `Forbrug: ${household}, ${period}`
}

export function sumUsageDistance(usages) {
  return usages.reduce((sum, row) => {
    if (isAdminBooking(row)) return sum
    return sum + Number(row.distance || 0)
  }, 0)
}

export function sumUsagePrice(usages) {
  return usages.reduce((sum, row) => {
    if (isAdminBooking(row)) return sum
    return sum + Number(row.totalPrice || 0)
  }, 0)
}

export function chauffeursLabel(subscription) {
  if (!subscription) return ''
  const n = subscription.chauffeurs
  return n === 1 ? '1 chauffør' : `${n} chauffører`
}
